<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "index.scss";
</style>
<template>
  <div class="purchase">
    <div style="display: flex; height: 40px; line-height: 40px">
      <h1>{{ $t('repeatShopping.title') }}</h1>
      <div style="flex-grow: 1"></div>
      <h1 style="font-size: 14px">复购分析仅支持iOS、Android平台的数据</h1>
    </div>
    <div class="purchase-box">
      <div class="purchase-daytype">
        <Button :class="daytype==='week'?'purchase-daytype-active':''" ghost-tmp shape="circle" size="small" @click="buttonChange('week')">{{ $t('repeatShopping.week') }}</Button>
        <Button :class="daytype==='month'?'purchase-daytype-active':''" ghost-tmp shape="circle" size="small" @click="buttonChange('month')">{{ $t('repeatShopping.month') }}</Button>
          <i class="daytype-icon iconfont icon-download" @click="download"></i>
        <Poptip trigger="hover" class="base-view-title-notab-pop" placement="bottom-end">
          <i class="daytype-icon  iconfont icon-help"></i>
          <div slot="title">{{ $t('portrait.indexInfo') }}</div>
          <div slot="content">
            <p><span>{{ $t('repeatShopping.repeat') }}：</span>{{ $t('repeatShopping.explain.repeat') }}</p>
            <p><span>{{ $t('repeatShopping.table.avg') }}：</span>{{ $t('repeatShopping.explain.avg') }}</p>
          </div>
        </Poptip>
      </div>
      <div style="position:relative; clear:both">
        <Table
            :columns="tableColumns"
            :data="tableData"
            :no-data-text="noData"
            class="purchase-table"
            @on-row-click="hidefilter"
            ref="table"
        ></Table>
        <div class="purchase-table-offset">
            {{tableTitle}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import bus from '../../libs/bus';
import util from '../../libs/util';
import numberSeparator from '../../filters/number-separator';
import dateFormat from '../../filters/date-format';

export default {
  components: {
  },
  filters: {
    numberSeparator,
    dateFormat,
  },
  data() {
    return {
      daytype: 'week',
      selectedDate: bus.selectedDate,
      // 表头相关
      columnsConfig: {
        day: {
          n: 7,
          step: 3600 * 1000 * 24,
        },
        week: {
          n: 8,
          step: 3600 * 1000 * 24 * 7,
        },
        month: {
          n: 6,
          step: 3600 * 1000 * 24 * 30,
        },
      },
      // 表格数据
      tableTitle: this.getTableTitle(),
      tableColumns: [],
      tableData: [],
      noData: this.$t('common.loading'),
      // 单元格样式设置参考上限
      max: 0,
      // 用于匹配
      mapData: {},
      // 用于计算每列平均值
      avgMapList: {
        week: [],
        month: [],
      },
      // 付费设备数列表
      payUserList: [],
      // 用户平均值
      userAvg: -1,
      // 第一列日期位移
      offset: 1,
      // 用于取消请求
      source: axios.CancelToken.source(),
      // 缓存（关键字格式为"开始时间_周／月"）
      dataCache: {},
    };
  },
  computed: {
    weekArray() {
      let start = new Date(bus.selectedDate[0]).valueOf();
      let end = new Date(bus.selectedDate[1]).valueOf();
      const step = this.columnsConfig.week.step;
      const result = [];
      // 获取开始日期所在周一
      let offset = new Date(start).getDay();
      offset = offset === 0 ? offset + 6 : offset - 1;
      start = new Date(start - (offset * 3600 * 1000 * 24)).valueOf();
      // 获取结束日期所在周日
      offset = new Date(end).getDay();
      offset = offset === 0 ? 6 - offset : 7 - offset;
      end = new Date(end + (offset * 3600 * 1000 * 24)).valueOf();
      for (; start + (3600 * 1000 * 24 * 6) <= end; start += step) {
        const item = [new Date(start).format('yyyy-MM-dd'),
          new Date(start + (3600 * 1000 * 24 * 6)).format('yyyy-MM-dd')];
        result.push(item);
      }
      return result;
    },
    monthArray() {
      const start = new Date(bus.selectedDate[0]);
      const end = new Date(bus.selectedDate[1]);
      let i = start.getMonth();
      let n = end.getMonth();
      const year = [
        start.getFullYear(),
        end.getFullYear(),
      ];
      if (year[0] !== year[1]) {
        n += 12;
      }
      const result = [];
      for (; i <= n; i += 1) {
        let s = null;
        let e = null;
        if (i <= 11) {
          s = new Date(year[0], i, 1).format('yyyy-MM-dd');
          e = new Date(new Date(year[0], i + 1, 1).valueOf() - (3600 * 1000 * 24))
            .format('yyyy-MM-dd');
        } else {
          s = new Date(year[1], i - 12, 1).format('yyyy-MM-dd');
          e = new Date(new Date(year[1], i - 11, 1).valueOf() - (3600 * 1000 * 24))
            .format('yyyy-MM-dd');
        }
        const item = [s, e];
        result.push(item);
      }
      return result;
    },
  },
  methods: {
    hidefilter() {
      bus.$emit('on-filter-hide');
    },
    /*
    **按钮切换
    **/
    buttonChange(str) {
      this.daytype = str;
      this.tableTitle = this.getTableTitle();
      this.init();
    },
    /**
     * 获取表格title
     **/
    getTableTitle() {
      const tmp = `repeatShopping.${(this.daytype || 'week')}`;
      let result = null;
      if (bus.lang === 'zh-CN') {
        result = `+N${this.$t(tmp)}${this.$t('repeatShopping.repeat')}`;
      } else {
        result = `${[this.$t(tmp)]} N ${this.$t('repeatShopping.repeat')}`;
      }
      return result;
    },
    /**
     * 获取表头
     * @param type {String} 类型
     **/
    getColumns(type) {
      const self = this;
      const n = this.columnsConfig[type].n + this.offset;
      const userAvg = self.userAvg < 0 ?
            '--' : numberSeparator((self.userAvg.toFixed(0) * 1));
      const list = [{
        key: 'date',
        title: self.$t('repeatShopping.table.date'),
        width: 90,
        align: 'center',
        ellipsis: true,
        renderHeader(h) {
          return h('dl', {
            class: 'purchase-table-columns',
          }, [
            h('dt', self.$t('repeatShopping.table.date')),
            h('dd', {
              class: 'separate',
            }),
            h('dd', self.$t('repeatShopping.table.avg'))]);
        },
//          return `<dl class='purchase-table-columns'>
//          <dt>${self.$t('repeatShopping.table.date')}</dt>
//          <dd class='separate'></dd><dd>${self.$t('repeatShopping.table.avg')}</dd></dl>`;
//        },
        render(h, params) {
          return h('Tooltip', {
            class: 'purchase-table-date',
            props: {
              content: params.row.date,
              placement: 'bottom-start',
            },
          }, params.row.date);
        },
      }, {
        key: 'user',
        title: self.$t('repeatShopping.table.pay'),
        width: 110,
        align: 'center',
        renderHeader(h) {
          return h('dl', {
            class: 'purchase-table-columns',
          }, [
            h('dt', self.$t('repeatShopping.table.pay')),
            h('dd', {
              class: 'separate',
            }),
            h('dd', userAvg)]);
//          return `<dl class='purchase-table-columns'>
//          <dt>${self.$t('repeatShopping.table.pay')}</dt>
//          <dd class='separate'></dd><dd>${userAvg}</dd></dl>`;
        },
        // render(row) {
        //   return `${numberSeparator(row.user)}`;
        // },
      }];
      // 获取数据列配置
      function getColumnItem(v, i, flag) {
        const name = (bus.lang === 'zh-CN') ? `+${i}${self.$t(`repeatShopping.${type}`)}` :
        `${self.$t(`repeatShopping.${type}`)} ${i}`;
        const item = {
          key: `column${i}`,
          title: name,
          align: 'center',
          renderHeader(h, params) {
            let tmp = '';
            const x = flag ? i : self.offset + (params.index - 2);
            if (bus.lang === 'zh-CN') {
              tmp = [h('strong', {
                domProps: {
                  innerHTML: `+${x}`,
                },
              }), h('span', self.$t(`repeatShopping.${type}`))];
//              tmp = `<strong>+${x}</strong>${self.$t(`repeatShopping.${type}`)}`;
            } else {
              tmp = [h('span', {
                domProps: {
                  innerHTML: self.$t(`repeatShopping.${type}`),
                },
              }), h('strong', x)];
//              tmp = `${self.$t(`repeatShopping.${type}`)} <strong>${x}</strong>`;
            }
            let value = '--';
            if (typeof (v) === 'number') {
              value = `${v.toFixed(1)}%`;
            }
            return h('dl', {
              class: 'purchase-table-columns',
            }, [
              h('dt', tmp),
              h('dd', {
                class: 'separate',
              }),
              h('dd', value),
            ]);
//            return `<dl class='purchase-table-columns'><dt>${tmp}</dt>
//            <dd class='separate'></dd><dd>${value}</dd></dl>`;
          },
        };
        list.push(item);
      }
      for (let i = this.offset; i < n; i += 1) {
        const value = self.averageArray()[i - this.offset];
        getColumnItem(value, i);
      }
      return list;
    },
    // 获取付费设备数
    fetchPayUserData() {
      const time = this.daytype === 'week' ? this.weekArray : this.monthArray;
      const timeArray = [];
      time.forEach((v) => {
        timeArray.push(v.join('/'));
      });
      const params = {
        developerId: bus.developerid,
        productId: bus.productid,
        metrics: ['placeOrderDevice'],
        platformIds: bus.platform,
        startTime: dateFormat(bus.selectedDate[0]),
        endTime: dateFormat(bus.selectedDate[1]),
        groupBy: this.daytype,
        timeList: timeArray,
        versions: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
        partnerIds: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
      };
      util.ajax.post('/app/rest/standardEvent/query', params).then((res) => {
        this.payUserList = res;
        this.fetchUserAndRows(0, this.daytype, res);
      });
    },
    // 获取付费设备数有效均值（即不为0的数且不包含最后一个数据的均值）
    getPayUserAvg() {
      const data = JSON.parse(JSON.stringify(this.payUserList.placeOrderDevice));
      data.pop();
      let sum = 0;
      let count = 0;
      data.forEach((v) => {
        if (v.value > 0) {
          sum += v.value;
          count += 1;
        }
      });
      this.userAvg = isNaN(sum / count) ? 0 : sum / count;
    },
    /**
     * 获取表格数据
     * @param type {String} 类型
     **/
    getTableData() {
      const result = [];
      const data = this.mapData;
      let sum = 0;
      let count = 0;
      for (const i of Object.keys(data)) {//  eslint-disable-line
        const item = {
          date: i,
          user: data[i].user,
          cellClassName: data[i].cellClassName,
        };
        for (let j = 2; j < this.tableColumns.length; j += 1) {
          let value = data[i].data && data[i].data[j - 2];
          if (value === undefined) {
            value = '';
          } else if (isNaN(value)) {
            value = 'N/A';
          } else {
            value += '%';
          }
          item[this.tableColumns[j].key] = value;
        }
        result.push(item);
        if (item.user > 0) {
          sum += data[i].user;
          count += 1;
        }
      }
      this.userAvg = isNaN(sum / count) ? 0 : sum / count;
//      this.tableColumns = this.getColumns(this.daytype);
      this.tableData = result;
      if (result.length === 0) {
        this.noData = this.$t('common.nodata');
      }
    },
    /**
     * 获取单元格样式
     * @param data {Array} 一行数据
     * @param type {String} 类型
     **/
    getCellClassName(data) {
      const result = {};
      for (let i = 2; i < this.tableColumns.length; i += 1) {
        if (data[i - 2] > this.max * 0.8) {
          result[this.tableColumns[i].key] = 'cell-larger';
        } else if (data[i - 2] > this.max * 0.6) {
          result[this.tableColumns[i].key] = 'cell-large';
        } else if (data[i - 2] > this.max * 0.4) {
          result[this.tableColumns[i].key] = 'cell-normal';
        } else if (data[i - 2] > this.max * 0.2) {
          result[this.tableColumns[i].key] = 'cell-light';
        } else if (data[i - 2] >= 0) {
          result[this.tableColumns[i].key] = 'cell-lighter';
        }
      }
      return result;
    },
    /**
     * 获取每列对应日期
     * @param date {String} 开始日期
     * @param type {String} 类型
     **/
    dayArray(date, type) {
      const n = this.columnsConfig[this.daytype].n;
      const step = this.columnsConfig[this.daytype].step;
      const result = [];
      let start = null;
      if (type === 'month') {
        start = new Date(date);
        const year = start.getFullYear();
        let month = start.getMonth() + this.offset;
        for (let i = 1; i <= n; month += 1, i += 1) {
          let item = null;
          if (month <= 11) {
            item = new Date(year, month, 1).format('yyyy-MM-dd');
            if (item > new Date().valueOf()) break;
          } else {
            item = new Date(year + 1, month - 12, 1).format('yyyy-MM-dd');
          }
          if (new Date(item).valueOf() > new Date().valueOf()) break;
          result.push(item);
        }
      } else {
        start = new Date(date).valueOf() + (step * this.offset);
        for (let i = 1; i <= n; start += step, i += 1) {
          if (start > new Date().valueOf()) break;
          const item = new Date(start).format('yyyy-MM-dd');
          result.push(item);
        }
      }
      return result;
    },
    /**
     * 求均值
     **/
    averageArray() {
      const n = this.columnsConfig[this.daytype].n;
      const data = this.avgMapList[this.daytype];
      if (data === {}) return [];
      const result = [];

      for (let i = 0; i < n; i += 1) {
        let sum = 0;
        let count = 0;
        for (const j of Object.keys(data)) {//  eslint-disable-line
          if (data[j][i] !== undefined && !isNaN(data[j][i])) {
            count += 1;
            sum += data[j][i];
          }
        }
        result.push((count ? sum / count : '--'));
      }
      return result;
    },
    /**
     * 按周(月)获取付费设备数
     * @param date {Array} 周(月)开始与结束日期
     * @param metric {String} 指标
     * @param max {Number} 最大值,限制返回几列数据
     **/
    fetchUserData(date, metric, max) {
      const params = {
        maxValue: max,
        developerId: bus.developerid,
        productId: bus.productid,
        metrics: [metric],
        platformIds: bus.platform,
        startTime: dateFormat(date[0]),
        endTime: dateFormat(date[1]),
        versions: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
        partnerIds: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
      };
      return util.ajax.post('/app/rest/standardEvent/query', params, {
        cancelToken: this.source.token,
      });
    },
    /**
     * 按周(月)获取用户和留存数
     * @param index {Number} 周(月)索引
     * @param type {String} 类型
     * @param payUserData {Object} 付费用户数列表
     **/
    fetchUserAndRows(index, type, payUserData) {
      const dates = type === 'week' ? this.weekArray : this.monthArray;
      // 截止到今天，距离开始日期的自然周
      const time = this.dayArray(dates[index][0], this.daytype);
      const maxLen = time.length;
      const metric = type === 'week' ? 'repurchaseWeek' : 'repurchaseMonth';
      this.fetchUserData(dates[index], metric, maxLen).then((res) => {
        const list = type === 'week' ? res.repurchaseWeek : res.repurchaseMonth;

        const item = {
          date: (type === 'week') ? dates[index].join('~') : dates[index][0].substr(0, 7),
          user: payUserData.placeOrderDevice[index].value,
        };
        const tmp = [];
        const mapMax = [];
        // 用于计算每列有效平均值（即每列去除最后一个数的均值）
        const avglist = [];
        for (let m = 0; m < list.length - 1; m += 1) {
          const num = this.calRate(list[m].value, item.user);
          avglist.push(num);
        }
        this.avgMapList[this.daytype].push(avglist);

        for (let i = 2; i < this.tableColumns.length; i += 1) {
          let value = list[i - 2] ? this.calRate(list[i - 2].value, item.user) : undefined;
          tmp.push(value);
          if (value === undefined) {
            value = '';
          } else if (isNaN(value)) {
            value = 'N/A';
          } else {
            mapMax.push(value);
            value += '%';
          }
          item[this.tableColumns[i].key] = value;
        }
        this.max = this.max > 0 ? this.max : Math.max.apply(null, mapMax) || 0;
        item.cellClassName = this.getCellClassName(tmp);
        this.mapData[item.date] = {
          user: payUserData.placeOrderDevice[index].value,
          data: tmp,
          cellClassName: item.cellClassName,
        };
//        this.tableColumns = this.getColumns(this.daytype);
        this.tableData.push(item);

        if (index + 1 >= dates.length) {
          // 将获取数据放入缓存, 求均值
          this.dataCache[`${bus.selectedDate[0]}_${this.daytype}`] = this.mapData;
          this.getPayUserAvg();
          this.tableColumns = this.getColumns(this.daytype);
          return true;
        }
        this.fetchUserAndRows(index + 1, type, payUserData);
        return false;
      }).catch((thrown) => {
        if (axios.isCancel(thrown)) {
          // 请求取消
        }
      });
    },
    /**
     * 下载表格数据
     **/
    download() {
      const filename = bus.getDownloadName(this.$t('repeatShopping.title'));
      this.$refs.table.exportCsv({
        filename,
      });
    },
    /**
     * 计算比率
     * @param up {Number} 分子
     * @param down {Number} 分母
     **/
    calRate(up, down) {
      return ((up / down) * 100).toFixed(1) * 1;
    },
    /**
     * 初始化
     * @param flag {Boolean} 是否清空缓存
     **/
    init(flag) {
      // 清除之前请求
      this.source.cancel('clear request');
      // 创建新的token
      this.source = axios.CancelToken.source();
      // 初始化
      this.noData = this.$t('common.loading');
      this.mapData = {};
      this.userAvg = -1;
      this.payUserList = [];
      this.tableColumns = this.getColumns(this.daytype);
      this.tableData = [];
      this.max = 0;
      if (flag) {
        this.dataCache = {};
        this.avgMapList = {
          week: [],
          month: [],
        };
      }
      const tmp = `${bus.selectedDate[0]}_${this.daytype}`;
      if (bus.productInfo.productid === '' || bus.productInfo.productid === undefined) {
        return;
      }
      if (this.dataCache[tmp]) {
        // 如果缓存中有，直接从缓存中获取数据进行处理展示
        this.mapData = this.dataCache[tmp];
        this.getTableData();
        this.tableColumns = this.getColumns(this.daytype);
      } else {
        this.fetchPayUserData();
      }
    },
  },
  mounted() {
    bus.$on('on-app-change', () => {
      this.init(true);
    });
    bus.$on('on-platform-change', () => {
      this.init(true);
    });
    bus.$on('on-conditions-change', () => {
      this.init(true);
    });
    bus.$on('on-date-change', () => {
      this.selectedDate = bus.selectedDate;
      this.init(true);
    });
    bus.$on('on-change-lang', () => {
      this.tableTitle = this.getTableTitle();
    });
    if (!bus.productid) {
      return;
    }
    this.init(true);
  },
  beforeDestroy() {
    bus.$off('on-app-change');
    bus.$off('on-platform-change');
    bus.$off('on-conditions-change');
    bus.$off('on-date-change');
    bus.$off('on-change-lang', () => {
      this.tableTitle = this.getTableTitle();
    });
  },
  watch: {},
};
</script>
